module.exports = __webpack_public_path__ + "img/icon_bonus.95f83a18.svg";